import React from 'react';
import {InertiaLink} from '@inertiajs/inertia-react';
import classNames from 'classnames';

export default ({ iconSrc, link, text, iconAlt }) => {
  const isActive = route().current(link + '*');

  const iconClasses = classNames('w-6 h-6 mr-2', {
    'text-white fill-current': isActive,
    'text-indigo-400 group-hover:text-white fill-current': !isActive
  });

  const textClasses = classNames({
    'text-white': isActive,
    'text-indigo-200 group-hover:text-white': !isActive
  });

  return (
    <div className="mb-4">
      <InertiaLink href={route(link)} className="flex items-center group py-3">
        <img className={iconClasses} src={iconSrc} alt={iconAlt}/>
        <div className={textClasses}>{text}</div>
      </InertiaLink>
    </div>
  );
};
